var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 73,
    viewBox: "0 0 70 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M37.45 0H10C4.47715 0 0 4.47715 0 10V21.9V51.1V63C0 68.5229 4.47716 73 10 73H37.45C42.9728 73 47.45 68.5229 47.45 63V10C47.45 4.47715 42.9728 0 37.45 0Z",
    fill: "#BE7637",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3999 47.4498L66.769 39.0807C68.1944 37.6553 68.1944 35.3443 66.769 33.9189L58.3999 25.5498M65.6999 36.4998L21.8999 36.4998",
    stroke: "#BE7637",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.3f0212d7ae1f2d0ce0532f8f1a775114.svg";
export { ForwardRef as ReactComponent };